import { getTenantById, listTenantSummaries, strictTenantId } from '../registry/tenants.js';

export function getTenantConfig(tenantId) {
  const strictId = strictTenantId(tenantId);
  if (!strictId) return null;
  return getTenantById(strictId);
}

export function requireTenantConfig(tenantId) {
  if (tenantId === null || tenantId === undefined || String(tenantId).trim() === '') {
    const error = new Error('Tenant is required');
    error.code = 'TENANT_REQUIRED';
    throw error;
  }

  const strictId = strictTenantId(tenantId);
  if (!strictId) {
    const error = new Error(`Invalid tenant id: ${tenantId}`);
    error.code = 'TENANT_INVALID';
    throw error;
  }

  const config = getTenantById(strictId);
  if (!config) {
    const error = new Error(`Unknown tenant: ${strictId}`);
    error.code = 'TENANT_NOT_FOUND';
    throw error;
  }
  return config;
}

export function getEnabledModules(tenantId) {
  const config = getTenantConfig(tenantId);
  if (!config?.modules) return [];
  return Object.entries(config.modules)
    .filter(([, moduleConfig]) => moduleConfig.enabled)
    .map(([key, moduleConfig]) => ({ key, label: moduleConfig.label, source: moduleConfig.source }));
}

export function isModuleEnabled(tenantId, moduleKey) {
  const config = getTenantConfig(tenantId);
  return config?.modules?.[moduleKey]?.enabled ?? false;
}

export function listTenants() {
  return listTenantSummaries();
}

export default { getTenantConfig, requireTenantConfig, getEnabledModules, isModuleEnabled, listTenants };
